(() => {
  'use strict';
  let rows = [];
  try { rows = JSON.parse(document.querySelector('[data-cover11-catalog]')?.textContent || '[]'); } catch (_) { rows = []; }
  rows = rows.filter(row => typeof row.id === 'string' && typeof row.href === 'string' && /^\/(?:[a-z]{2}(?:-[a-zA-Z]{2})?\/)?pages\/vehicles\//.test(row.href) && Number.isInteger(row.y0) && Number.isInteger(row.y1) && row.y0 <= row.y1 && Array.isArray(row.cfgs));
  const registry = new Map(rows.map(row => [row.id, { ...row, status: 'live', years: `${row.y0}–${row.y1}`, short: row.id }]));
  const catalog = rows.map(row => [row.make, row.model, row.y0, row.y1, 'live', row.id]);
  const resolve = id => registry.get(id) || null;
  window.COVER11_CATALOG = [...registry.values()];
  window.COVER11_GARAGE = () => {
    try {
      const saved = JSON.parse(localStorage.getItem('solum-garage') || '[]');
      if (!Array.isArray(saved)) return [];
      return saved.slice(0, 4).flatMap(item => {
        const row = item && resolve(item.gen || item.id);
        if (!row || item.year && (!Number.isInteger(+item.year) || +item.year < row.y0 || +item.year > row.y1)) return [];
        if (item.cfg && !row.cfgs.includes(item.cfg)) return [];
        return [{ id: row.id, gen: row.id, name: row.name, model: row.model, year: item.year ? +item.year : null, cfg: item.cfg || null, href: row.href }];
      });
    } catch (_) { return []; }
  };
  window.SOLUM_DB = {
    CAT: catalog,
    gen: tuple => resolve(tuple[5]) || [...registry.values()].find(row => row.make === tuple[0] && row.model === tuple[1] && row.y0 === tuple[2] && row.y1 === tuple[3]) || null,
    genById: resolve,
    models: () => [...new Map([...registry.values()].map(row => [row.key, { key: row.key, make: row.make, model: row.base, name: `${row.make} ${row.base}` }])).values()],
    gens: key => [...registry.values()].filter(row => row.key === key),
    popular: () => [...registry.values()].slice(0, 8),
    offers: () => [],
    forGarage: () => null,
    pageRule: () => ({ index: false, code: 'REQUIRES_VARIANT_FITMENT' })
  };
  const target = new URLSearchParams(location.search).get('g');
  const legacyPaths = ['/pages/vehicle', '/pages/model', '/pages/vehicle-category'];
  if (target && legacyPaths.some(p => location.pathname.endsWith(p))) {
    const row = resolve(target);
    if (row) location.replace(row.href);
  }
})();
